import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { PayableApprovalsListPage } from "@/screens/Accounting/subfeatures/PayableApprovals"
import { payableApprovalsSearchParamsSchema } from "@/screens/Accounting/subfeatures/PayableApprovals/types/searchParams"

export const Route = createFileRoute("/app/accounting/_layout/payable-approvals")({
  validateSearch: zodValidator(payableApprovalsSearchParamsSchema),
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "dueDateFrom", "dueDateTo"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.PAYABLE_APPROVAL]}>
      <PayableApprovalsListPage />
    </PermissionContentWrapper>
  ),
})
